import React from 'react'
import HeaderSection from '../../../../components/common/Header/HeaderSection'
import AddForm from './AddForm'
import { Box } from '@chakra-ui/react';

const Liability = () => {
    return (
        <div>
            <HeaderSection
                title="Liability Voucher"
                breadcrumb={["Dashboard", "Voucher", "Liability List"]}
            />
                        <Box p={6}>

            <AddForm />
            </Box>
        </div>
    )
}

export default Liability